import { t as __exportAll } from "./chunk-pbuEa-1d.js";
import { n as ok, t as err } from "./result-D_NYcfr2.js";
import { n as fs_exports } from "./fs-6FuEguuO.js";
import { match } from "ts-pattern";
import { pathToFileURL } from "node:url";
import { execFile, spawn } from "node:child_process";
//#region src/node/path.ts
var path_exports = /* @__PURE__ */ __exportAll({
	toImportUrl: () => toImportUrl,
	toPosixPath: () => toPosixPath
});
/**
* Convert a filesystem path to an ESM import specifier (a `file://` URL).
*
* Required wherever a filesystem path becomes a JavaScript import string —
* dynamic `import()` calls or static import specifiers embedded in generated
* source code. On Windows, raw paths like `C:\foo\bar.ts` contain `\f`, `\b`,
* `\u`, and other sequences that JavaScript parses as string escapes, which
* either crashes the bundler or breaks runtime resolution. The `file://` URL
* form is platform-neutral (`file:///C:/foo/bar.ts` on Windows,
* `file:///foo/bar.ts` on POSIX).
*
* @param filePath - An absolute filesystem path.
* @returns A `file://` URL string suitable as an ESM import specifier.
*/
function toImportUrl(filePath) {
	return pathToFileURL(filePath).href;
}
/**
* Normalize a native path string to use forward-slash separators.
*
* `path.relative()` and `path.join()` return separators native to the OS
* (`\` on Windows, `/` elsewhere). When paths flow into string operations —
* regex matching, `includes()` / `startsWith()` checks, template-engine
* lookups — Windows backslashes silently break POSIX-shaped patterns.
* Normalizing once at the boundary lets downstream code assume `/`.
*
* Node's `path.join()` accepts forward slashes on Windows and produces
* correct native paths during filesystem operations, so the normalized form
* remains usable for subsequent path composition.
*
* @param p - A native path string.
* @returns The path with all `\` replaced by `/`.
*/
function toPosixPath(p) {
	return p.replaceAll("\\", "/");
}
//#endregion
//#region src/node/process.ts
var process_exports = /* @__PURE__ */ __exportAll({
	exec: () => exec,
	exists: () => exists,
	spawn: () => spawn$1
});
/**
* Execute a command with arguments and return the result.
*
* Wraps `child_process.execFile` into an async Result tuple. On failure,
* the error includes stderr as a property for diagnostic access.
*
* @param params - The command and arguments to execute.
* @returns A result tuple with stdout/stderr on success or an Error on failure.
*/
function exec(params) {
	const { cmd, args = [], cwd } = params;
	return new Promise((resolve) => {
		execFile(cmd, [...args], {
			cwd,
			shell: needsShell()
		}, (error, stdout, stderr) => {
			if (error) {
				const enriched = new Error(`${cmd} failed: ${error.message}`, { cause: error });
				Object.defineProperty(enriched, "stderr", {
					enumerable: true,
					value: stderr
				});
				resolve(err(enriched));
				return;
			}
			resolve(ok({
				stdout,
				stderr
			}));
		});
	});
}
/**
* Spawn an interactive process with inherited stdio.
*
* Returns the exit code of the child process. Stdio is inherited so the
* child process shares the parent's terminal.
*
* @param cmd - The command to spawn.
* @param args - Arguments to pass to the command.
* @param cwd - Working directory for the child process.
* @returns The exit code of the spawned process.
*/
function spawn$1(params) {
	return new Promise((resolve) => {
		const child = spawn(params.cmd, [...params.args], {
			cwd: params.cwd,
			shell: needsShell(),
			stdio: "inherit"
		});
		child.on("error", () => {
			resolve(1);
		});
		child.on("close", (code) => {
			resolve(code ?? 1);
		});
	});
}
/**
* Check whether a binary is available on the system PATH.
*
* Uses `which` (unix) or `where` (windows) to resolve the binary
* without executing it.
*
* @param cmd - The command name to check.
* @returns `true` when the command is found on PATH.
*/
function exists(cmd) {
	const lookup = match(process.platform).with("win32", () => "where").otherwise(() => "which");
	return new Promise((resolve) => {
		execFile(lookup, [cmd], (error) => {
			resolve(error === null);
		});
	});
}
/**
* Whether the current platform requires `shell: true` for `child_process`
* calls.
*
* Evaluated at call time rather than captured at module load so tests that
* stub `process.platform` get a fresh value, and so the result is never
* frozen against a value that was true only at startup.
*
* On Windows, npm/pnpm-installed CLIs (e.g. `tsx`) ship as `.cmd` shim
* files that Node's `child_process` can't launch via `CreateProcess` —
* only `cmd.exe` can. `shell: true` routes through `cmd.exe` so the shim
* runs. On POSIX it's unnecessary and changes argument escaping, so it's
* gated to Windows.
*
* @private
* @returns `true` on Windows, `false` elsewhere.
*/
function needsShell() {
	return process.platform === "win32";
}
//#endregion
export { fs_exports as fs, path_exports as path, process_exports as process };

//# sourceMappingURL=node.js.map